import React from 'react';
import RichTextEditor from 'Components/UI/RichTextEditor';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

const RichTextWithHelper = ({
  helperText, className, classes, ...rest
}) => (
  <div className={classNames(classes.root, className)}>
    <RichTextEditor {...rest} />
    {helperText}
  </div>
);

export default withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
})(RichTextWithHelper);
